function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4424 10.5459C13.8922 10.5459 16.7998 11.2748 16.7998 12.7246V14.5068H10.7324L9.25195 12.7246C9.25195 11.4664 10.9927 10.5461 12.4424 10.5459ZM18.3193 10.4326C19.9263 10.4326 23.1475 11.2274 23.1475 12.8096V14.5068H18.3193V12.9785C18.3192 12.4013 18.0913 11.3893 16.6846 10.6221C17.2845 10.4999 17.8642 10.4326 18.3193 10.4326ZM18.3193 5C19.4642 5 20.3887 5.90987 20.3887 7.03711C20.3887 8.16434 19.4642 9.07422 18.3193 9.07422C17.1746 9.07407 16.2578 8.16424 16.2578 7.03711C16.2578 5.90996 17.1746 5.00015 18.3193 5ZM12.4424 5C13.5356 5 14.415 5.88724 14.415 6.98047C14.415 8.07375 13.5357 8.96094 12.4424 8.96094C11.3493 8.96073 10.4619 8.07362 10.4619 6.98047C10.462 5.88737 11.3493 5.00021 12.4424 5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.51 17.38C17.28 17.38 16.09 17.18 14.98 16.82C14.63 16.7 14.24 16.79 13.97 17.06L12.4 19.03C9.57 17.68 6.92 15.13 5.51 12.2L7.46 10.54C7.73 10.26 7.81 9.87 7.7 9.52C7.33 8.41 7.14 7.22 7.14 5.99C7.14 5.45 6.69 5 6.15 5H2.69C2.15 5 1.5 5.24 1.5 5.99C1.5 15.28 9.23 23 18.51 23C19.22 23 19.5 22.37 19.5 21.82V18.37C19.5 17.83 19.05 17.38 18.51 17.38Z",
  fill: "white"
}));

function SvgConference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConference);
export default __webpack_public_path__ + "static/media/conference.76b3414f.svg";
export { ForwardRef as ReactComponent };